import { mdiMenu } from "@mdi/js";
import { Buis } from "~/components/Buis";
import { Group } from "~/components/ui/group";
import { ActionIcon } from "~/components/ui/icon";
import { Separator } from "~/components/ui/separator";
import { Sheet, SheetContent } from "~/components/ui/sheet";
import { Spacer } from "~/components/ui/spacer";
import { BoldText } from "~/components/ui/text";
import { useDocumentContext } from "../../../providers/context";
import { DocumentBookmarkButton } from "../Buttons/bookmark";
import { DocumentNextArticleButton, DocumentPreviousArticleButton } from "../Buttons/direction";
import { DocumentDownloadButton } from "../Buttons/download";
import { DocumentSpeechButton } from "../Buttons/speech";
import { ContentFrame } from "../ContentFrame";
import { DocumentMobileSidebar } from "../Sidebar/mobile";

export function MobileRoot() {
	const { documentTitle, selected, sheetOpen, setSheetOpen } = useDocumentContext();

	return (
		<>
			<Group
				class="mb-4"
				align="stretch"
			>
				<BoldText class="text-xl font-bold my-auto">{documentTitle()}</BoldText>
				<Spacer />
				<ActionIcon
					path={mdiMenu}
					variant="light"
					onclick={() => setSheetOpen(true)}
				/>
			</Group>
			<Group class="mb-6">
				<DocumentPreviousArticleButton />
				<DocumentNextArticleButton />
				<Spacer />
				<DocumentSpeechButton />
				<DocumentBookmarkButton />
				<DocumentDownloadButton />
			</Group>
			<Separator class="mb-6" />
			<Buis
				class="mb-4 text-lg"
				value={selected()?.title}
			/>
			<ContentFrame article={selected} />
			<Sheet
				open={sheetOpen()}
				onOpenChange={setSheetOpen}
			>
				<SheetContent
					class="w-full p-0 relative overflow-y-auto"
					position="left"
				>
					<DocumentMobileSidebar />
				</SheetContent>
			</Sheet>
		</>
	);
}
